export default __webpack_public_path__ + "static/media/Q10_1_resized.5f52e15e.jpg";